import { MinMaxValues } from "src/@types/filtering";
import { ISelectOption } from "src/@types/form";
import {
  QueryParamSettingsObject,
  QueryParamKeys,
  QueryParamVariableNames,
} from "./types";

export const EMPLOYEE_COUNT_OPTIONS: ISelectOption[] = [
  { id: "0-100", label: "<10", value: "<10" },
  { id: "10-50", label: "10-50", value: "10-50" },
  { id: "50-*", label: "50>", value: ">50" },
];

export const YEAR_ON_THE_MARKET_OPTIONS: ISelectOption[] = [
  { id: "0-2", label: "<2", value: "<2" },
  { id: "2-5", label: "2-5", value: "2-5" },
  { id: "5-*", label: "5>", value: ">5" },
];

export const CUSTOMER_COUNT_OPTIONS: ISelectOption[] = [
  { id: "0-1000", label: "<1000", value: "<1000" },
  { id: "1000-*", label: "1000>", value: ">1000" },
];

export const SEPARATOR = ",";
export const RANGE_SEPARATOR = ",";

// const INITIAL_MIN = 0;
// const INITIAL_MAX = 100000;

// export const MIN_MAX_TUPLE = [
//   INITIAL_MIN.toString(),
//   INITIAL_MAX.toString(),
// ] as const;

const generateMinMaxTuple = (minValue: number, maxValue: number) =>
  [minValue?.toString(), maxValue?.toString()] as const;

export const generateQueryParamsSettingItems = (
  values: MinMaxValues
): QueryParamSettingsObject[] => [
  {
    key: QueryParamKeys.SEARCH,
    variableName: QueryParamVariableNames.SEARCH,
  },
  {
    key: QueryParamKeys.MIN_INVESTMENT,
    variableName: QueryParamVariableNames.MIN_INVESTMENT,
    isMultiple: true,
    separator: RANGE_SEPARATOR,
    defaultValue: values
      ? generateMinMaxTuple(
          values.min_investment_for_start,
          values.max_investment_for_start
        )
      : [],
  },
  {
    key: QueryParamKeys.LIST_PRICE,
    variableName: QueryParamVariableNames.LIST_PRICE,
    isMultiple: true,
    separator: RANGE_SEPARATOR,
    defaultValue: values
      ? generateMinMaxTuple(values.min_cost, values.max_cost)
      : [],
  },
  {
    key: QueryParamKeys.INDUSTRY,
    variableName: QueryParamVariableNames.INDUSTRY,
    isMultiple: true,
    separator: SEPARATOR,
    defaultValue: [],
  },
  {
    key: QueryParamKeys.BUSINESS_TYPE,
    variableName: QueryParamVariableNames.BUSINESS_TYPE,
    isMultiple: true,
    separator: SEPARATOR,
    defaultValue: [],
  },
  {
    key: QueryParamKeys.EMPLOYEE_COUNT,
    variableName: QueryParamVariableNames.EMPLOYEE_COUNT,
    isMultiple: true,
    separator: SEPARATOR,
    defaultValue: [],
  },
  {
    key: QueryParamKeys.YEARS_ON_THE_MARKET,
    variableName: QueryParamVariableNames.YEARS_ON_THE_MARKET,
    isMultiple: true,
    separator: SEPARATOR,
    defaultValue: [],
  },
  {
    key: QueryParamKeys.CUSTOMER_COUNT,
    variableName: QueryParamVariableNames.CUSTOMER_COUNT,
  },
  {
    key: QueryParamKeys.ANNUAL_TURNOVER,
    variableName: QueryParamVariableNames.ANNUAL_TURNOVER,
    isMultiple: true,
    separator: RANGE_SEPARATOR,
    defaultValue: values
      ? generateMinMaxTuple(
          values.min_annual_turnover,
          values.max_annual_turnover
        )
      : [],
  },
  {
    key: QueryParamKeys.MONTHLY_INCOME,
    variableName: QueryParamVariableNames.MONTHLY_INCOME,
    isMultiple: true,
    separator: RANGE_SEPARATOR,
    defaultValue: values
      ? generateMinMaxTuple(
          values.min_monthly_income,
          values.max_monthly_income
        )
      : [],
  },
];
